export default "__VITE_ASSET__BXZ9AiQ$__"